class ProductNostoTabs extends HTMLElement {
  constructor () {
    super()

    this.tabEls = this.querySelectorAll('[data-el="product-nosto-tabs.tab"]')
    this.navEl = this.querySelector('[data-el="product-nosto-tabs.nav"]')
  }

  connectedCallback () {
    this.tabEls.forEach(tabEl => {
      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            // Handle added nodes here
            const addedNodes = Array.from(mutation.addedNodes)
            addedNodes.forEach(node => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                if (node.querySelector('h2')) {
                  const placementId = node.closest('.nosto_element').id

                  const heading = this.extractHeading(node)
                  this.headings = [...this.headings, { heading, placementId }]
                }
              }
            })
          }
        })
      })

      observer.observe(tabEl, {
        childList: true,
        subtree: true,
      })
    })

    setTimeout(() => {
      this.removePreserveSpace()
    }, 5000)
  }

  removePreserveSpace () {
    this.classList.remove('prd-NostoTabs-preserveSpace')
  }

  setupListeners () {
    this.navItemEls = this.querySelectorAll(
      '[data-el="product-nosto-tabs.navItem"]',
    )

    this.handleTabClick()
  }

  handleTabClick () {
    this.navItemEls.forEach(navItemEl => {
      navItemEl.addEventListener('click', this.handleClick.bind(this))
    })
  }

  extractHeading (node) {
    const heading = node.querySelector('h2')

    return heading.textContent
  }

  handleClick (event) {
    const activeTabIndex = event.target.dataset.tabIndex

    this.navItemEls.forEach(navItemEl => {
      if (navItemEl.dataset.tabIndex === activeTabIndex) {
        navItemEl.setAttribute('aria-current', true)
      } else {
        navItemEl.setAttribute('aria-current', false)
      }
    })

    this.tabEls.forEach(tabEl => {
      if (tabEl.dataset.tabIndex === activeTabIndex) {
        tabEl.setAttribute('aria-current', true)
      } else {
        tabEl.setAttribute('aria-current', false)
      }
    })
  }

  buildNavItem (heading, index) {
    const li = document.createElement('li')

    li.classList.add('prd-NostoTabs_NavItem')
    li.classList.add('fz-34_37')
    li.setAttribute('data-el', 'product-nosto-tabs.navItem')
    li.setAttribute('data-tab-index', index)
    li.setAttribute('aria-current', index === 0)
    li.textContent = heading

    return li
  }

  get headings () {
    return this._headings || []
  }

  get blockOrder () {
    return this.navEl.dataset.blockOrder.split(',')
  }

  set headings (headings) {
    this._headings = headings

    this.navEl.innerHTML = ''

    this.blockOrder.forEach((block, index) => {
      const heading = this.headings.find(
        heading => heading.placementId === block,
      )

      if (heading) {
        const li = this.buildNavItem(heading.heading, index)

        li.setAttribute('data-placement-id', heading.placementId)

        this.navEl.insertAdjacentElement('beforeend', li)

        const handle = heading.heading
          .replace(/\n/g, '')
          .trim()
          .toLowerCase()
          .replace(/\s+/g, '-')

        const gtmTargetContext = `nosto-tabs-${handle}`
        const gtmItemListName = `nosto-tabs-${handle}`

        this.querySelectorAll('.prd-NostoTabs_Tab')[index].setAttribute(
          'data-gtm-target-context',
          gtmTargetContext,
        )
        this.querySelectorAll('.prd-NostoTabs_Tab')[index].setAttribute(
          'data-gtm-item-list-name',
          gtmItemListName,
        )
      }
    })

    this.setupListeners()
  }
}

if (!customElements.get('product-nosto-tabs')) {
  customElements.define('product-nosto-tabs', ProductNostoTabs)
}
